import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ShareDataService } from 'core/data-services/share/share.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Helpers } from 'helpers';
import { AlertService, AuthenticationService } from 'pages/authentication/_services';
import { ParkingDataService } from 'core/data-services/parking/parking.service';
import { MainAlertService } from 'helpers/services/main-alert.service';
import {AccessHelper} from 'helpers/access.helper';

declare let $ :any;
declare let mLayout: any;

@Component({
  selector: "app-header-nav",
  templateUrl: "./header-nav.component.html",
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./header-nav.component.scss']
})
export class HeaderNavComponent implements OnInit, AfterViewInit {
  accessHelper = AccessHelper;
  userInfo: any;
  branch: any;
  isSubmit: boolean;
  constructor(private http: HttpClient,
              private shareDataService: ShareDataService,
              private fb: FormBuilder,
              private _alertService: AlertService,
              private parkingDataService: ParkingDataService,
              private mainAlertService: MainAlertService,
              private _authService: AuthenticationService)  {

  }

  public changePasswordForm: any = this.fb.group({
    id: [''],
    email: [''],
    oldPassword: ['', [
      Validators.required,
    ]],
    password: ['', [
      Validators.minLength(8),
      Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])([A-Z]|[a-z]|[0-9]){8,20}$/i)
    ]],
    confirmPassword: ['', [Validators.minLength(8)]],
  }, {
    validator: [
      this.licenseConfirmPasswordValidator()
    ]
  });

  ngOnInit()  {
    this.getUserInfo();
    this.initSelectParking();

  }

  ngAfterViewInit()  {
    mLayout.initHeader();
  }

  initSelectParking() {
    $(document).ready(() => {
      $('#parkingLotFilterSelect').selectpicker();
      $('.btn-group.bootstrap-select button').css({'min-width': '250px'});
    });
  }

  getUserInfo() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
  }

  onSelectBranch(branch): void {
    this.branch = branch;
    this.shareDataService.changeBranch(branch);
  }

  changePassword() {
    this.isSubmit = false
    this.changePasswordForm.controls['id'].setValue(this.userInfo.id);
    this.changePasswordForm.controls['email'].setValue(this.userInfo.email);
    this.changePasswordForm.controls['oldPassword'].setValue('');
    this.changePasswordForm.controls['password'].setValue('');
    this.changePasswordForm.controls['confirmPassword'].setValue('');
    $('#changePasswordModal').modal('toggle');
  }

  formattedValue() {
    let passwordBody = {
      oldPassword: this.changePasswordForm.value.oldPassword,
      newPassword: this.changePasswordForm.value.password,
    };
    return passwordBody;
  }

  licenseConfirmPasswordValidator() {
    return (group: FormGroup): { [key: string]: any } => {
      if (!group.value.password && !group.value.confirmPassword) {
        return null;
      }

      if (group.value.password === group.value.confirmPassword) {
        return null;
      } else {
        return {
          confirmPasswordValidator: true
        };
      }
    }
  }

  onSubmit() {
    this.isSubmit = true;
    if (this.changePasswordForm.valid) this.updatePassword();
  }

  updatePassword() {
    Helpers.setLoading(true);
    this.parkingDataService.changePassword(this.formattedValue())
        .then((response: any) => {
          Helpers.setLoading(false);
          this.isSubmit = false;
          this.mainAlertService.generateAlert('success', 'เปลี่ยนรหัสผ่านสำเร็จ!');
          $('#changePasswordModal').modal('toggle');
          this._authService.logout()
        }).catch((error) => {
      this.isSubmit = false;
      Helpers.setLoading(false);
      this.mainAlertService.alertAPIError(error);
      $('#changePasswordModal').modal('toggle');
    });
  }

}




// WEBPACK FOOTER //
// ./src/app/theme/layouts/header-nav/header-nav.component.ts